import { PerformanceItemRankingData } from "./performance-item-ranking-data";

export class ProgrammePerformanceItemRankingChange {
  programmeId: string;
  rankingList: PerformanceItemRankingData[];

  constructor(
      programmeId: string,
      rankingList: PerformanceItemRankingData[] = []
    ) { 
      this.programmeId = programmeId;
      this.rankingList = rankingList;
    }
}
